<template>
  <!-- Homepage d'un module -->
  <div>
    <v-container class="pt-0 pb-5">
      <v-row>
        <!-- Sidebar des infos modules -->
        <v-col lg="3" cols="12" class="order-md-first order-xl-first order-last">
          <div class="pa-2 rounded elevation-1 bg-white">
            <ModuleProperties></ModuleProperties>
          </div>
        </v-col>
        <!-- Contenu de la page -->
        <v-col lg="9">
          <div class="pa-2 rounded elevation-1 bg-white">
            <!-- Bouton de switch billetterie/sportif -->
            <SwitchButtonBilletterieToSportif v-if="display_switch_button"></SwitchButtonBilletterieToSportif>
            <!-- Countdown ouverture du module -->
            <OpenDateMessage></OpenDateMessage>
            <!-- Message relatif au PPS -->
            <PPSMessage v-if="mainStore.module.accept_pps && !mainStore.billetterie_mode"></PPSMessage>
            <!-- Message d'informations supplémentaires -->
            <HomeMessage></HomeMessage>

            <ListCourses v-if="!mainStore.billetterie_mode"></ListCourses>
            <ListPacks v-if="!mainStore.billetterie_mode"></ListPacks>

            <BottomInscriptionSection v-if="!mainStore.billetterie_mode"></BottomInscriptionSection>
            <ListOptions></ListOptions>
            <ListActivites></ListActivites>
            <ListArticles></ListArticles>


          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useBookingStore } from "@/stores/bookingStore";
import ModuleProperties from "@/components/Home/Module_Properties.vue";
import BottomInscriptionSection from "@/components/Home/Bottom_Inscription_Section.vue";
import ListCourses from "@/components/Home/Courses/List_Courses.vue";
import ListPacks from "@/components/Home/Packs/List_Packs.vue";
import ListOptions from "@/components/Home/Options/List_Options.vue";
import ListActivites from "@/components/Home/Activites/List_Activites.vue";
import ListArticles from "@/components/Home/Articles/List_Articles.vue";
import SwitchButtonBilletterieToSportif from "@/components/Home/Switch_Button_Billetterie_To_Sportif.vue";
import HomeMessage from "@/components/Home/Home_Message.vue";
import OpenDateMessage from "@/components/Home/Open_Date_Message.vue";
import PPSMessage from "@/components/Home/PPS_Message.vue";
export default {
  data() {
    return {
    };
  },
  components: { ModuleProperties, BottomInscriptionSection, ListCourses, ListPacks, ListOptions, ListActivites, ListArticles, SwitchButtonBilletterieToSportif, HomeMessage, OpenDateMessage, PPSMessage },
  computed: {
    ...mapStores(useMainStore, useBookingStore),
    display_switch_button() {
      return this.mainStore.billetterie_mode && this.$route.params.base_module.includes("BILLETTERIE_");
    }
  },
  async mounted() {
    await this.mainStore.init_view_as_admin(this.$route.query.admin_token);
    await this.mainStore.init_inscription_as_admin(this.$route.query.admin_ins);
    this.mainStore.dossard_bourse_mode = false;
    this.bookingStore.clearState();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/Home.scss";
</style>
